import React from 'react';
import {
  Button,
  Confirm,
  Dropdown,
  Header,
  Image,
  Form,
  Icon,
  Tab,
} from 'semantic-ui-react';
import Details from './offer/details';
import Messages from '../Messages.js';
import { inlineStyle } from '../../styles/custom';
import { languages } from '../../constants';
import FileUploadButton from '../fileUploadButton';
import PermissionsManager from '../PermissionsManager';

const renderShops = (shops) => {
  let _shops = [{ value: null, text: '--' }];

  if (shops !== undefined) {
    shops.forEach((shop) => {
      _shops.push({ value: shop.id, text: shop.name });
    });
  }

  return _shops;
};

const renderPageBuilders = (pageBuilders) => {
  let _pageBuilders = [{ value: null, text: '--' }];

  if (pageBuilders !== undefined) {
    pageBuilders.forEach((pageBuidler) => {
      if (
        pageBuidler.blocks.filter((e) => e.type === 'time_block').length >= 1
      ) {
        _pageBuilders.push({
          value: pageBuidler.id,
          text: pageBuidler.detail.meta_title,
        });
      }
    });
  }

  return _pageBuilders;
};

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  return panes;
};

const OfferForm = ({
  obj,
  status,
  shops,
  pageBuilders,
  onChange,
  onSubmit,
  onDelete,
}) => {
  return (
    <Form>
      <Header>Offre{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Messages errors={status.errors} />
      <Form.Field>
        <label>Choisir une enseigne OU une page</label>
        {shops.loading ? (
          <div>Chargement des enseignes</div>
        ) : (
          <Dropdown
            placeholder="Sélectionnez une enseigne"
            fluid
            selection
            closeOnChange
            id="shop_id"
            value={obj.shop_id}
            options={renderShops(shops.getShops)}
            onChange={(param, data) => onChange(param, data, 'dropdown')}
          />
        )}
        <br />
        {pageBuilders.loading ? (
          <div>Chargement des pages</div>
        ) : (
          <Dropdown
            placeholder="Sélectionnez une page"
            fluid
            selection
            closeOnChange
            id="page_builder_id"
            value={obj.page_builder_id}
            options={renderPageBuilders(pageBuilders.getPageBuilders)}
            onChange={(param, data) => onChange(param, data, 'dropdown')}
          />
        )}
      </Form.Field>
      <Form.Field>
        {typeof obj.image === 'string' ? (
          <Image src={obj.image} size="tiny" />
        ) : null}
        <FileUploadButton id="image" label="Vignette" onChange={onChange} />
      </Form.Field>
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br />
      <br />
      <Form.Field>
        <PermissionsManager hasPermissions={['create_offer', 'update_offer']}>
          {status.loading ? (
            <Button type="submit" floated="left" color="red" loading>
              {' '}
              Chargement...
            </Button>
          ) : (
            <Button
              type="submit"
              floated="left"
              color="olive"
              onClick={onSubmit}
            >
              <Icon name="save" /> Sauvegarder
            </Button>
          )}
        </PermissionsManager>
        {!status.isNew ? (
          <div>
            <PermissionsManager hasPermissions={['delete_offer']}>
              <Button
                type="submit"
                color="red"
                floated="right"
                onClick={(Offer, data) => {
                  onDelete(Offer, { confirm: true });
                }}
              >
                <Icon name="delete" /> Suppression
              </Button>
            </PermissionsManager>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer cette offre ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(Offer, data) => {
          onDelete(Offer, { confirm: null });
        }}
        onConfirm={(Offer, data) => {
          onDelete(Offer, { confirm: false });
        }}
        style={inlineStyle.modal}
        cancelButton="Annuler"
        confirmButton="Ok"
      />
    </Form>
  );
};

export default OfferForm;



// WEBPACK FOOTER //
// ./src/components/form/Offer.js